export const quickSave = () => ({
  external: true,
  method: 'quickSave',
});
